module.exports = __webpack_public_path__ + "static/media/close.6d8ef1b3.svg";